import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUsSection from '../../components/feature/WhyChooseUsSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTASection from '../../components/feature/FinalCTASection';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import MidPageCTA from '../../components/feature/MidPageCTA';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';

const homeFAQs = [
  {
    question: 'Who provides environmental remediation near me in Colorado?',
    answer:
      'ECOS Environmental & Disaster Restoration provides certified remediation services including asbestos removal, mold remediation, and hazardous material handling across Colorado. Their team is licensed and trained to handle high-risk environmental projects safely and in full regulatory compliance with EPA and OSHA standards.',
  },
  {
    question: 'How much does environmental remediation cost?',
    answer:
      'Costs vary depending on site size, type of materials involved, and contamination level. ECOS Environmental provides detailed site assessments to deliver accurate, project-specific pricing. All assessments are free, and full compliance documentation is included with every project.',
  },
  {
    question: 'How long does remediation take?',
    answer:
      'Project timelines depend on scope and complexity. Smaller remediation projects may take a few days, while larger or hazardous environments can take several weeks. ECOS Environmental prioritizes efficiency while maintaining strict safety and compliance standards throughout.',
  },
  {
    question: 'Are you licensed and insured for environmental work in Colorado?',
    answer:
      'Yes. ECOS Environmental holds full state licensing, all current EPA and OSHA certifications, and comprehensive insurance coverage for all environmental remediation and disaster restoration work throughout Colorado and surrounding regions.',
  },
  {
    question: 'Do you offer 24/7 emergency environmental response?',
    answer:
      'Yes. ECOS Environmental maintains rapid-response emergency teams available 24 hours a day, 7 days a week for environmental emergencies including contamination events, flood damage, mold outbreaks, and hazardous material incidents across Colorado.',
  },
];

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <TrustBar />
      <ServicesOverview />
      <MidPageCTA />
      <AIAnswerBlock
        question="What Does ECOS Environmental & Disaster Restoration Do?"
        answer="ECOS Environmental & Disaster Restoration provides certified environmental remediation and disaster restoration services including asbestos removal, hazardous material handling, mold remediation, lead paint removal, and emergency site cleanup. They help commercial, industrial, and government clients maintain compliance with EPA and OSHA environmental regulations while ensuring safe, efficient, and fully documented project execution across Colorado and surrounding regions."
      />
      <ProcessSection />
      <WhyChooseUsSection />
      <ServiceAreasSection />
      <TestimonialsSection />
      <MidPageCTA
        headline="Ready to Schedule Your Environmental Assessment?"
        subtext="Our certified specialists deliver project-specific assessments with full compliance planning."
      />
      <FAQSection faqs={homeFAQs} title="Common Questions About Environmental Remediation" />
      <FinalCTASection />
      <Footer />
    </main>
  );
}
